import { create } from 'zustand';

// ── WHO IS DRIVING ───────────────────────────────────────────────────────────
//
// UI-level driving state (React subscribes to this): which car you are near,
// whether you are in one, and a few numbers for the dash. The per-frame physics
// lives in plain objects inside Vehicles — the store is written only when
// something a person would SEE changes (a prompt appears, you get in), never at
// frame rate.
//
// `driveBridge` is the frame-rate half, read by the walking rig to stand down
// and by the HUD's speedometer through its own rAF.
export const useDriveStore = create((set) => ({
  near: null,        // index of the parked car you could take, or null
  driving: null,     // index of the car you are in, or null
  setNear: (near) => set((s) => (s.near === near ? {} : { near })),
  setDriving: (driving) => set({ driving }),
}));

export const driveBridge = {
  active: false,     // true while a car owns the camera
  speed: 0,          // world units / second, signed
  rpm: 0,
  gear: 'D',
  request: null,     // 'enter' | 'exit' — set by the key/touch handlers, consumed by Vehicles
  parked: [],        // the kerbside cars ({ x, z, h }, by index), live — the street's car radios read them (components/city/CitySounds)
};

// One place the F key (and the touch button) asks to get in or out.
export function requestToggle() {
  driveBridge.request = driveBridge.active ? 'exit' : 'enter';
}
